<mibi-box-layout>
    <button
        *ngIf="keycloakEnabled; else legacyForm"
        class="mibi-login-submit-button"
        mat-flat-button
        color="accent"
        type="button"
        (click)="onLoginKeycloak()"
    >Anmelden</button>

    <ng-template #legacyForm>
        <form [formGroup]="loginForm" (ngSubmit)="onLoginLegacy()">
            <div class="mibi-form-group">
                <mibi-form-field>
                    <mat-form-field>
                        <mat-label>E-Mail</mat-label>
                        <input
                            matInput
                            placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                            name="email"
                            formControlName="email"
                            required
                        >
                    </mat-form-field>
                </mibi-form-field>
            </div>
            <div class="mibi-form-group">
                <mibi-form-field>
                    <mat-form-field>
                        <mat-label>Passwort</mat-label>
                        <input
                            matInput
                            placeholder="Geben Sie Ihr Passwort ein"
                            type="password"
                            name="password"
                            formControlName="password"
                            required
                        >
                    </mat-form-field>
                </mibi-form-field>
            </div>
            <button
                class="mibi-login-submit-button"
                mat-flat-button
                color="accent"
                type="submit"
                [disabled]="!loginForm.valid"
            >Anmelden</button>
        </form>
    </ng-template>
</mibi-box-layout>
